import React, { memo, useMemo } from 'react';
import styled from 'styled-components';
import { Box, Text } from 'pcln-design-system';
import dayNameBuilder from '../utils/dayNameBuilder/dayNameBuilder';
const DayName = /*#__PURE__*/styled(Box).withConfig({
  displayName: "DayNames__DayName",
  componentId: "sc-3by3ve-0"
})(["&&&{display:inline-block;vertical-align:top;text-transform:capitalize;padding:2px 0;text-align:center;}"]);
function DayNames({
  locale
}) {
  const memoizedDays = useMemo(() => dayNameBuilder({
    format: 'abbreviated',
    locale
  }), [locale]);
  return React.createElement(Box, {
    pt: '10px'
  }, memoizedDays.map((name, index) => React.createElement(DayName, {
    key: name,
    width: 1 / 7,
    "data-testid": `day-name-${index}`
  }, React.createElement(Text, {
    fontSize: 0,
    color: 'text.light'
  }, name))));
}
export default memo(DayNames);